import { Grid } from '@mui/material'
import { CircleButton } from './NumberButton'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

const SignButton = ({
    icon,
    label,
    onClick,
}: {
    icon: any
    label: string
    onClick: () => void
}) => {
    const { isLandscapeMobile, isMobile, isLandscapeTablet } = useScreenSize()
    return (
        <CircleButton
            isSmall={isLandscapeMobile || isMobile || isLandscapeTablet}
            isSign={true}
            isActive={false}
            onClick={onClick}
        >
            <Grid container direction="column">
                <Grid item>{icon}</Grid>
                <Grid item>{label}</Grid>
            </Grid>
        </CircleButton>
    )
}

export default SignButton
